import {
    handleRehydrateAction,
    handleRemoveAction,
    handleSubmitAction
} from '../../../core/store/helpers/reducer-helper';
import * as fromFormActions from '../form/form.actions';
import * as fromControlActions from './control.actions';
import { Control } from './control.model';
import { updateFromApiReducer } from './update-from-api.reducer';

export interface State {
    ids: Array<string>;
    entities: {[id: string]: Control};
}

export const initialState: State = {
    ids: [],
    entities: {}
};

// tslint:disable-next-line:only-arrow-functions
export function reducer(
    state = initialState,
    action: fromControlActions.Actions | fromFormActions.Actions
): State {
    switch (action.type) {
        case fromControlActions.SUBMIT: {
            return handleSubmitAction(state, action);
        }
        case fromControlActions.REHYDRATE: {
            return handleRehydrateAction(state, action);
        }
        case fromControlActions.REMOVE: {
            return handleRemoveAction(state, action);
        }
        case fromFormActions.UPDATE_FROM_API: {
            return updateFromApiReducer(state, action);
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control/control.reducer.ts